import axios from "../axios";
import Cookies from "js-cookie";


export const CreateNewSurvey = async (AssessmentName,Description) => {
  const token = Cookies.get("employeeToken");

  return axios.post("/api/Assessment/CreateAssessment", {
    token,AssessmentName,Description
  });
};

export const GetAllSurvey = async () => {
  const token = Cookies.get("employeeToken");

  return axios.post("/api/Assessment/GetCreatedAssessment", {
    token
  });
};

export const GetSurveyAndQuestionDetails = async (assessmentUID) => {
  const token = Cookies.get("employeeToken");

  return axios.post("/api/Assessment/GetAssessmentDetails", {
    token,assessmentUID
  });
};

export const CreateQuestion = async (assessmentUID, question, answerType, optionList) => {
  const token = Cookies.get("employeeToken");

  return axios.post("/api/Assessment/CreateQuestion", {
    token,
    assessmentUID,
    question,
    answerType,
    optionList,
  });
};
